import { faComments } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fab } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

interface ChatFabProps {
  totalUnreadCount: number;
  className?: string;
  onToggle: () => void;
}

const ChatFabRoot = styled('div')(({ theme }) => ({
  position: 'fixed',
  bottom: theme.baseUnit * 2,
  right: theme.baseUnit * 2,
  zIndex: 1300,
}));

const ChatFabInner = styled('div')({
  position: 'relative',
});

const ChatFabButton = styled(Fab)(({ theme }) => ({
  backgroundColor: theme.colors.alias.primary,
  color: theme.colors.alias.textContrast,
  '&:hover': {
    backgroundColor: theme.colors.alias.primary,
  },
}));

const ChatFabBadge = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: -8,
  right: -8,
  backgroundColor: theme.colors.red[500],
  color: theme.colors.alias.textContrast,
  borderRadius: '50%',
  minWidth: 20,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 11,
  fontWeight: 600,
  zIndex: 1301,
  border: `2px solid ${theme.colors.alias.mainBackground}`,
  boxShadow: theme.shadows[2],
}));

const ChatFab: React.FC<ChatFabProps> = ({
  totalUnreadCount,
  className,
  onToggle,
}) => (
  <ChatFabRoot>
    <ChatFabInner>
      <ChatFabButton
        onClick={onToggle}
        className={className}
        aria-label="Open chat"
      >
        <FontAwesomeIcon icon={faComments} aria-hidden />
      </ChatFabButton>
      {totalUnreadCount > 0 && (
        <ChatFabBadge aria-hidden>
          {totalUnreadCount > 99 ? '99+' : totalUnreadCount}
        </ChatFabBadge>
      )}
    </ChatFabInner>
  </ChatFabRoot>
);

export default ChatFab;
